import React from 'react';
import styles from './tip.scss';

class Tip extends React.Component {
    constructor(props) {
        super(props);
        this.setWrapperRef = this.setWrapperRef.bind(this);
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }

    render() {
        const { showTip, align, valign, customStyle, content, dangerouslySetInnerHTML, isComponent } = this.props;

        return (
            <div ref={this.setWrapperRef} className={`${styles.tipRoot}`}>
                {this.props.children}
                {showTip && (
                    <div style={customStyle} className={`${styles.tipInfoRoot} ${valign === 'top' ? styles.top : styles.middle}  ${align === 'left' ? styles.left : styles.right} `}>
                        <div className={`alert alert-info-utr`} role="alert">
                            { dangerouslySetInnerHTML === true && (
                                <div dangerouslySetInnerHTML={{ __html: content }} />
                            )}
                            {isComponent === true && (
                                <div>
                                    {content}
                                </div>
                            )}
                            {dangerouslySetInnerHTML !== true && isComponent !== true && (
                                <div>
                                    {`${content}`}
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Tip;
